import { NewdanhmucphieunhapService } from 'src/services/newdanhmucphieunhap.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const NEWDANHMUCPHIEUNHAP_NEW_CARE_SUCCESS = 'NEWDANHMUCPHIEUNHAP:NEW_CARE_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_LIST_SUCCESS = 'NEWDANHMUCPHIEUNHAP:FIND_ALL_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_LIST_FAILD = 'NEWDANHMUCPHIEUNHAP:FIND_ALL_FAILD'
export const NEWDANHMUCPHIEUNHAP_COUNT_ASSIGN_SUCCESS = 'NEWDANHMUCPHIEUNHAP:COUNT_ASSIGN_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_COUNT_ASSIGN_FAILD = 'NEWDANHMUCPHIEUNHAP:COUNT_ASSIGN_FAILD'

export const NEWDANHMUCPHIEUNHAP_CREATE_SUCCESS = 'NEWDANHMUCPHIEUNHAP:CREATE_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_CREATE_FAILD = 'NEWDANHMUCPHIEUNHAP:CREATE_FAILD'

export const NEWDANHMUCPHIEUNHAP_IMPORT_SUCCESS = 'NEWDANHMUCPHIEUNHAP:IMPORT_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_SAVE_SUCCESS = 'NEWDANHMUCPHIEUNHAP:SAVE_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_SAVE_FAILD = 'NEWDANHMUCPHIEUNHAP:SAVE_SUCCESS'

export const NEWDANHMUCPHIEUNHAP_DEL_SUCCESS = 'NEWDANHMUCPHIEUNHAP:DEL_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_DEL_FAILD = 'NEWDANHMUCPHIEUNHAP:DEL_FAILD'

export const NEWDANHMUCPHIEUNHAP_ONE_SUCCESS = 'NEWDANHMUCPHIEUNHAP:FIND_ONE_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_ONE_FAILD = 'NEWDANHMUCPHIEUNHAP:FIND_ONE_FAILD'

export const NEWDANHMUCPHIEUNHAP_HISTORY_LIST_SUCCESS = 'NEWDANHMUCPHIEUNHAP:HISTORY_FIND_ALL_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_HISTORY_LIST_FAILD = 'NEWDANHMUCPHIEUNHAP:HISTORY_FIND_ALL_FAILD'

export const NEWDANHMUCPHIEUNHAP_UPDATE_FILTER = 'NEWDANHMUCPHIEUNHAP:NEWDANHMUCPHIEUNHAP_UPDATE_FILTER'

export const NEWDANHMUCPHIEUNHAP_LIST_EXPORT_SUCCESS = 'NEWDANHMUCPHIEUNHAP:FIND_ALL_EXPORT_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_LIST_EXPORT_FAILD = 'NEWDANHMUCPHIEUNHAP:FIND_ALL_EXPORT_FAILD'

export const NEWDANHMUCPHIEUNHAP_UPDATE_HOMEPAGE_FILTER = 'NEWDANHMUCPHIEUNHAP:NEWDANHMUCPHIEUNHAP_UPDATE_HOMEPAGE_FILTER'

export const NEWDANHMUCPHIEUNHAP_HOMEPAGE_LIST_SUCCESS = 'NEWDANHMUCPHIEUNHAP:FIND_HOMEPAGE_LIST_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_HOMEPAGE_LIST_FAILD = 'NEWDANHMUCPHIEUNHAP:FIND_HOMEPAGE_LIST_FAILD'

export const NEWDANHMUCPHIEUNHAP_HOMEPAGE_ONE_SUCCESS = 'NEWDANHMUCPHIEUNHAP:FIND_HOMEPAGE_ONE_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_HOMEPAGE_ONE_FAILD = 'NEWDANHMUCPHIEUNHAP:FIND_HOMEPAGE_ONE_FAILD'

export const NEWDANHMUCPHIEUNHAP_ORDER_SUCCESS = 'NEWDANHMUCPHIEUNHAP:ORDER_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_ORDER_FAILD = 'NEWDANHMUCPHIEUNHAP:ORDER_FAILD'

export const NEWDANHMUCPHIEUNHAP_GET_SIM_ANALYSIS_SUCCESS = 'NEWDANHMUCPHIEUNHAP:GET_SIM_ANALYSIS_SUCCESS'
export const NEWDANHMUCPHIEUNHAP_GET_SIM_ANALYSIS_FAILD = 'NEWDANHMUCPHIEUNHAP:GET_SIM_ANALYSIS_FAILD'

export const NEWDANHMUCPHIEUNHAP_HANDLE_IMPORT_ERRORS = 'NEWDANHMUCPHIEUNHAP:NEWDANHMUCPHIEUNHAP_HANDLE_IMPORT_ERRORS'

export const NewdanhmucphieunhapAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
    checkSoKhungSoMay,
}

function checkSoKhungSoMay(payload) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmucphieunhapService.checkSoKhungSoMay(payload).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmucphieunhapService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: NEWDANHMUCPHIEUNHAP_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { newdanhmucphieunhap } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageNewdanhmucphieunhapFilter } = newdanhmucphieunhap;
        const homepageNewdanhmucphieunhapPage = homepageNewdanhmucphieunhapFilter.homepageNewdanhmucphieunhapPage;
        const homepageNewdanhmucphieunhapLimit = homepageNewdanhmucphieunhapFilter.homepageNewdanhmucphieunhapLimit;

        return new Promise((resolve, reject) => {
            NewdanhmucphieunhapService.homepageList(homepageNewdanhmucphieunhapFilter).then((rs) => {
                if (!!homepageNewdanhmucphieunhapFilter && homepageNewdanhmucphieunhapFilter.homepageNewdanhmucphieunhapPage === 0) {
                    dispatch(success({
                        homepageNewdanhmucphieunhapItems: rs.data.values,
                        homepageNewdanhmucphieunhapTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucphieunhap.homepageNewdanhmucphieunhapItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageNewdanhmucphieunhapLimit * homepageNewdanhmucphieunhapPage; i < homepageNewdanhmucphieunhapLimit * homepageNewdanhmucphieunhapPage + homepageNewdanhmucphieunhapLimit; i++) {
                        if (typeof rsDataValues[i - homepageNewdanhmucphieunhapLimit * homepageNewdanhmucphieunhapPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageNewdanhmucphieunhapLimit * homepageNewdanhmucphieunhapPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageNewdanhmucphieunhapItems: uniqueItems,
                        homepageNewdanhmucphieunhapTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieunhapService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: NEWDANHMUCPHIEUNHAP_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      NewdanhmucphieunhapService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieunhapService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { newdanhmucphieunhap } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieunhapService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucphieunhap.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucphieunhapService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(NewdanhmucphieunhapAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: NEWDANHMUCPHIEUNHAP_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucphieunhapService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { newdanhmucphieunhap } = getState();

            const { filter } = newdanhmucphieunhap;

            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucphieunhapService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { newdanhmucphieunhap } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = newdanhmucphieunhap;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            NewdanhmucphieunhapService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucphieunhap.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: NEWDANHMUCPHIEUNHAP_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucphieunhapService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(NewdanhmucphieunhapAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_SAVE_FAILD, error } }
}

function create(payload, creatingFromAway = false) {
    return dispatch => {
        if (!creatingFromAway)  dispatch(AppAction.appLoading(true));
        NewdanhmucphieunhapService.create(payload).then((rs) => {
            dispatch(success(rs));
            if (!creatingFromAway) dispatch(NewdanhmucphieunhapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng số phiếu!");
        }).finally(() => {
            if (!creatingFromAway) dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieunhapService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucphieunhapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng số phiếu!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieunhapService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucphieunhapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_DEL_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        return new Promise((resolve, reject) => {
            NewdanhmucphieunhapService.find(id).then((rs) => {
                dispatch(success(rs.data));
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieunhapService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(NewdanhmucphieunhapAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { newdanhmucphieunhap } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieunhapService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucphieunhap.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucphieunhapService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCPHIEUNHAP_ORDER_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCPHIEUNHAP_ORDER_FAILD, error } }
}